import React from "react";
import { Link } from "react-router-dom";
import "../styles/LandingPage.css";
import TopNav from "../components/TopNav";
import FooterBar from "../components/FooterBar";
import seal from "../assets/seal-s3.png";

function LandingPage() {
  return (
    <div className="ucx-body">
      <TopNav />

      <main className="ucx-main">
        <section className="ucx-hero">
          <div className="ucx-container ucx-hero-grid">
            <div>
              <h1>Anti-Counterfeit Verification Network</h1>
              <p className="ucx-hero-text">
                UNI-CODEX assigns global manufacturer prefixes, generates secure
                product identity codes, and powers instant verification for
                consumers, retailers, and regulators.
              </p>
              <div className="ucx-hero-actions">
                <Link to="/verify" className="ucx-btn ucx-btn-primary">
                  Verify a Code
                </Link>
                <Link to="/apply" className="ucx-btn ucx-btn-outline">
                  Apply for Manufacturer Prefix
                </Link>
              </div>
              <p className="ucx-hero-note">
                Scan, type, or tap a code to verify
                authenticity in seconds.
              </p>
            </div>

            <div className="ucx-hero-card">
              <img src={seal} alt="UNI-CODEX Seal" className="ucx-seal" />
              <h2>Unified Authenticity Ledger</h2>
              <ul className="ucx-list">
                <li>Global manufacturer prefix registry</li>
                <li>Secure product identity codes per batch</li>
                <li>Real-time verification responses</li>
                <li>Suspicious, expired, and recall status flags</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="ucx-section">
          <div className="ucx-container ucx-grid-3">
            <div className="ucx-card">
              <h3>For Manufacturers</h3>
              <p>
                Apply for a UNI-CODEX manufacturer prefix, register products and
                batches, and give your customers a fast, trusted authenticity
                check.
              </p>
              <Link to="/apply" className="ucx-link">
                Apply for a prefix →
              </Link>
            </div>

            <div className="ucx-card">
              <h3>For Retailers</h3>
              <p>
                Verify each product at point-of-sale or receiving. Flag
                suspicious codes and protect your shelves from counterfeit
                goods.
              </p>
              <Link to="/verify" className="ucx-link">
                Verify a code →
              </Link>
            </div>

            <div className="ucx-card">
              <h3>For Regulators</h3>
              <p>
                Access batch lineage, recall markers, and verification logs to
                trace products through the supply chain.
              </p>
              <Link to="/docs" className="ucx-link">
                View documentation →
              </Link>
            </div>
          </div>
        </section>

        <section className="ucx-section ucx-section-alt">
          <div className="ucx-container ucx-grid-2">
            <div>
              <h2>How UNI-CODEX Works</h2>
              <ol className="ucx-steps">
                <li>Manufacturers apply for a unique UNI-CODEX prefix.</li>
                <li>Approved manufacturers register products and batches.</li>
                <li>
                  UNI-CODEX generates secure code ranges per product/batch.
                </li>
                <li>Codes are printed on packaging or labels.</li>
                <li>
                  Consumers and retailers verify codes via this portal.
                </li>
              </ol>
            </div>
            {/*<div>
              <h2>Fast to Deploy. Hard to Forge.</h2>
              <p>
                The system is designed to be easy to roll out on standard
                hosting, while keeping code generation logic protected and
                verification flows secure.
              </p>
            </div>*/}
          </div>
        </section>
      </main>

      <FooterBar />
    </div>
  );
}

export default LandingPage;
